export default function hasFbaMultipleFnSku(box) {
    if (!box || box.is_fba_box !== true) return false
    const list = Array.isArray(box.fn_sku) ? box.fn_sku : []
    return new Set(list.filter(Boolean)).size > 2
}
